import I18n from '~/i18n';
import partnerStatusEnum from '~/enums/partnerStatusEnum';
import { appName } from '../uri';

const trAttr = (attr) => I18n.t(`packageBilling.attributes.${attr}`);

export const packageOptions = {
  users:     'Adicional de Usuários',
  emergency: 'Botão de Pânico',
  driving:   'Direção Inteligente',
  doctor:    `${appName} Médico`,
  month:     'Mensal',
  semester:  'Semestral',
  year:      'Anual',
  manually:  'Nova Assinatura',
  auto_renew:'Renovação'
};

const config = () => [
  { title: trAttr('user_id'), field: 'user_id', type: 'numeric', hidden: true},
  { title: trAttr('package_id'), field: 'package_id', type: 'numeric', hidden: true},
  { title: trAttr('transaction_at'), field: 'transaction_at', type: 'datetime'},
  { title: trAttr('expires_at'), field: 'expires_at', type: 'datetime', hidden: true},
  { title: trAttr('price'), field: 'price', type: 'numeric', hidden: true},
  { title: trAttr('product_id'), field: 'product_id', type: 'string', hidden: true},
  { title: trAttr('transaction_id'), field: 'transaction_id', type: 'string', hidden: true},
  { title: trAttr('store'), field: 'store', type: 'string', hidden: true},
  { title: trAttr('state'), field: 'state', type: 'string', hidden: true},
  { title: trAttr('user_name'), field: 'user_name', type: 'string'},
  { title: trAttr('pack_name'), field: 'pack_name', type: 'string', hidden: true},
  { title: trAttr('pack_type'), field: 'pack_type', type: 'string',
    lookup: packageOptions,
  },
  { title: trAttr('period'), field: 'period', type: 'string',
    lookup: packageOptions,
  },
  { title: trAttr('origin'), field: 'origin', type: 'string',
    lookup: packageOptions,
  },
  { title: trAttr('pack_size'), field: 'pack_size', type: 'string'},
  { title: trAttr('partner_status'), field: 'partner_status', type: 'string',
    lookup: partnerStatusEnum().objects()
  },
  { title: trAttr('partner'), field: 'partner', type: 'string'},
];

export default config;
